import React from 'react';
import dayjs from 'core/utils/dayjs';
import OfferOverlayLink from 'core/modules/OfferOverlayLink/OfferOverlayLink';
import MerchantRebateV2 from 'core/modules/MerchantRebateV2/MerchantRebateV2';
import ReadMore from 'core/modules/ReadMore/ReadMore';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import {
  addPeriodAfterOfferRolloverCopy,
} from 'core/utils/apis/responseParsers/commonParsers/addPeriodAfterOfferRolloverCopy';

import './OfferTableItemDesktopContent.scss';

// Limit offer's text to fit into layout
const MAX_TEXT_LENGTH = 120;

function OfferTableDesktopContent({ dataItem, sectionId, rebateOptions }) {
  const {
    id, assets: { text, callToActionText }, stopDatetime, merchant, couponCode, isOngoing,
  } = dataItem;

  const {
    id: merchantId, rebate, name, logoUrls: { _88x31 },
  } = merchant;

  const expiredDate = dayjs.parseZone(stopDatetime).format('MMM DD, YYYY');
  const customRebateOptions = {
    hideRebatePrefix: true, showRebateInline: true, hideElevationCurrency: true, ...rebateOptions,
  };
  const textFormatted = addPeriodAfterOfferRolloverCopy(text);
  const expiredPrefix = isOngoing ? 'Ongoing' : `Valid through ${expiredDate}`;

  return (
    <div
      className="mn_textOfferItemDesktop"
      data-test="offer-table-item"
      data-section-type={sectionId}
      data-merchant-name={name}
      data-merchant-id={merchantId}
      data-offer-id={id}
      data-offer-text={text}
      role="listitem"
    >
      <div className="mn_offerMrch">
        <OfferOverlayLink merchantId={merchantId} merchantName={name} offerId={id} sectionId={sectionId}>
          <img src={_88x31} alt={name} />
        </OfferOverlayLink>
      </div>
      <div className="mn_offerItemContent">
        <div className="mn_offerDet">
          <ReadMore
            data-test="offer-item-text"
            text={textFormatted}
            moreLinkText="More"
            maxTextLength={MAX_TEXT_LENGTH}
          >
            {' '}
            <span className="mn_expired" data-test="offer-item-expiry-text">
              {expiredPrefix}
            </span>
          </ReadMore>
        </div>
        <MerchantRebateV2 {...rebate} {...customRebateOptions} />
        {couponCode &&
          <div className="mn_codeWrap">
            <div className="mn_codeInfo" data-test="coupon-code">
              <span className="mn_codeLabel">With promo:&nbsp;</span>
              <span className="mn_copyCouponCode">{couponCode}</span>
            </div>
          </div>
        }
      </div>
      <div className="mn_shopNowWrap">
        <OfferOverlayLink
          merchantId={merchantId}
          merchantName={name}
          offerId={id}
          sectionId={sectionId}
          className="mn_button mn_secondaryButton"
        >
          {callToActionText || 'Shop now'}
        </OfferOverlayLink>
      </div>
    </div>
  );
}

export default (props) =>
  <ComponentErrorBoundary><OfferTableDesktopContent {...props} /></ComponentErrorBoundary>;
